/**
 * Determinate progress: a bar that fills left to right. While it is short
 * of 100 a sheen moves across the fill so a long step still looks alive.
 * Loading in this app is always a bar, never a circle (John's rule).
 */
export function ProgressBar({ value, className = '' }: { value: number; className?: string }) {
  const pct = Math.max(0, Math.min(100, value))
  return (
    <div
      className={`h-1.5 w-full overflow-hidden rounded-full bg-surface-3 ${className}`}
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className={`h-full rounded-full bg-accent transition-[width] duration-700 ease-out ${pct < 100 ? 'progress-fill-active' : ''}`}
        style={{ width: `${pct}%` }}
      />
    </div>
  )
}
